import Model, { attr, belongsTo } from "@ember-data/model";

export default class ShipmentModel extends Model {
  @attr trackingid;
  @attr datacenter;
  @attr status;
  @attr createdat;

  @belongsTo("remote-hands-request", { async: false, inverse: "shipments" }) remoteHandsRequest;
  @belongsTo("project", { async: false, inverse: "shipments" }) project;

  get isRegistered() {
    return this.status?.toLowerCase() === "registered";
  }

  get isPending() {
    return this.status?.toLowerCase() === "pending";
  }

  get isReceived() {
    return this.status?.toLowerCase() === "received";
  }

  get isDelivered() {
    return this.status?.toLowerCase() === "delivered";
  }

  get isCanceled() {
    return this.status?.toLowerCase() === "canceled";
  }

  get isCancelable() {
    return this.isPending || this.isRegistered;
  }

  get isEditable() {
    return this.isPending || this.isRegistered;
  }

  get isNotCancelable() {
    return !this.isCancelable;
  }
}
